/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Price_Page_Visit_SingleInputs */

const en_price_page_visit_single = /** @type {(inputs: Price_Page_Visit_SingleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A single visit`)
};

const pl_price_page_visit_single = /** @type {(inputs: Price_Page_Visit_SingleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pojedyncza wizyta`)
};

/**
* | output |
* | --- |
* | "A single visit" |
*
* @param {Price_Page_Visit_SingleInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const price_page_visit_single = /** @type {((inputs?: Price_Page_Visit_SingleInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Price_Page_Visit_SingleInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_price_page_visit_single(inputs)
	return en_price_page_visit_single(inputs)
});